import React from 'react';

import './actionConfirmationModal.scss';

import PropTypes from 'prop-types';
import {ModalDialog, TextAreaField} from '../../../../../@elixir/components';

export class ActionConfirmationModal extends React.Component {

    static contextTypes = {
        title: PropTypes.string,
        message: PropTypes.number,
        actionHandler: PropTypes.func,
        translator: PropTypes.func
    };

    constructor (props) {
        super(props);

        this.state = {messageToUser: ''};
    }

    onCancel () {
    }

    onAction () {
        this.props.actionHandler(this.state.messageToUser);
    }

    handleMessageChange (newValue) {
        this.setState({messageToUser: newValue});
    }

    render () {
        const {
            title,
            message
        } = this.props;

        const {
            messageToUser
        } = this.state;

        return (
            <ModalDialog
                className="actionConfirmationModal"
                onCancel={this.onCancel.bind(this)}
                onAction={this.onAction.bind(this)}
                showCancelBtn={true}
                cancelBtnLabel={'Cancel'}
                showSaveBtn={false}
                saveBtnLabel={''}
                actionBtnLabel={'Continue'}
                title={title}
                centerTitle={false}>
                {message}

                <TextAreaField
                    className="messageToUserInput"
                    id="textarea"
                    path="textarea"
                    value={messageToUser}
                    rows={2}
                    showOptional={false}
                    onValueChange={this.handleMessageChange.bind(this)}
                />
            </ ModalDialog>
        );
    }
}

